import PropTypes from 'prop-types'
import { mapIssueToForm } from 'shared_src/mappings/issue'

import { Paper } from '../../../shared/NarusMaterial'

import IssueForm from './IssueForm'

const IssueFormWrapper = ({
  row,
  magicGridIndex,
  onCancel,
  onSave,
  currentUser,
  formKey
}) => (
  <Paper>
    <IssueForm
      formKey={formKey}
      onCancel={() => onCancel(magicGridIndex)}
      onSubmit={data => onSave(data, magicGridIndex)}
      value={mapIssueToForm(row, currentUser)}
      currentUser={currentUser}
    />
  </Paper>
)

IssueFormWrapper.propTypes = {
  row: PropTypes.instanceOf(Object),
  magicGridIndex: PropTypes.number,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  currentUser: PropTypes.instanceOf(Object)
}

export default IssueFormWrapper
